import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { InvoiceForm, type ClientOption, type CompanyOption, type PaymentTermOption } from "../../features/invoices/InvoiceForm"

type EditInvoiceProps = {
  invoice: {
    id: number
    codigo_sap: string
    cr: string
    company_id: number | null
    client_id: number | null
    municipio: string
    ibge_codigo_municipio_prestacao?: string
    medicao: string
    periodo_inicio: string
    periodo_fim: string
    valor: string
    omie_servico_id?: number | null
    omie_conta_corrente_id?: number | null
    payment_term_id?: number | null
  }
  companies: CompanyOption[]
  clients: ClientOption[]
  payment_terms?: PaymentTermOption[]
  errors?: Record<string, string[]>
}

export default function EditInvoice({ invoice, companies, clients, payment_terms, errors }: EditInvoiceProps) {
  return (
    <>
      <Head title="Editar Nota Fiscal" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Editar Nota Fiscal</h1>
            <p className="text-slate-400">Atualize os dados da nota fiscal selecionada.</p>
          </div>
          <InvoiceForm
            initialValues={invoice}
            companies={companies}
            clients={clients}
            paymentTerms={payment_terms}
            submitUrl={`/notas-fiscais/${invoice.id}`}
            submitLabel="Salvar alterações"
            method="patch"
            errors={errors}
          />
        </div>
      </AppLayout>
    </>
  )
}
